import { render, staticRenderFns } from "./ReintegriList.vue?vue&type=template&id=641539f3"
import script from "./ReintegriList.vue?vue&type=script&lang=ts"
export * from "./ReintegriList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('641539f3')) {
      api.createRecord('641539f3', component.options)
    } else {
      api.reload('641539f3', component.options)
    }
    module.hot.accept("./ReintegriList.vue?vue&type=template&id=641539f3", function () {
      api.rerender('641539f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ReintegriList.vue"
export default component.exports